export default __webpack_public_path__ + "static/media/nc.597a3b4b.svg";